import React, { Fragment, Suspense, lazy } from "react";
import { withStyles } from "@material-ui/core";
import { withUserProfile } from "../../../../userProfile/userProfileContext";
import ShipmentGridConfig from "./ShipmentsGridConfig";
import RouteConfirmationModal from "./RouteConfirmationModal";
import DataGrid from '@dataGrid';
import { observer, inject } from "mobx-react";
import { autorun, reaction } from "mobx";
import appConstant from "../../../../appConstants";
import MESSAGES from "../../../../appMessages";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import { isValid as isDateTimeValid } from "date-fns";
import { postData } from "../../../../api/componentAPIs";
import { isEqual } from "lodash/lang";
import StatusBar from '@dataGrid/components/StatusBar';
import { AppLoading } from "../../../../loaders/loaders";
import CheckViolation from "../../../common/checkViolation";
import GeocodingModal from "../../Common/Geocoding/GeoCodingModal";
import { getShipmentCustomerData } from "../../Common/Geocoding/utils";
import { RMAXLogger } from "../../../../services/LoggerService/RMAXLogger";
import { withAppConfig } from "../../../../appConfigContext";
import { withFeatureFlags } from "../../../../userProfile/featureFlagsContext";
import { getSpecialNeedsOptionsWithServiceLevel } from "../../utils";
import Events from "../../../../utilities/EventEmitter";
import { COLUMN_CONFIG } from "./constant";
import CustomConfirmationDialog from "../../Dispatch/RouteExecution/DriverPopUp/common/CustomConfirmationDialog";
import { getRelatedEquipmentFields, isEquipmentSizeField } from "./utils";
import { EQUIPMENT_TYPE_BY_FIELD } from "../../CustomerManagement/EditCustomer/constants";
import HoldProPopup from "./HoldProPopup";
import { handleWhiteGloveProMove } from "../Common/whiteGloveRouteUtils";
const ProImages = lazy(() => import("@ProImages"));

const styles = (theme) => ({
  highlightText: {
    color: theme.HeaderSelectedText,
  },
});
@inject("IBPlanningStore", "CommonStore")
@observer
class ShipmentsGrid extends React.Component {
  constructor(props) {
    super(props);
    this.gridConfig = new ShipmentGridConfig({
      userConfig: this.props.userData.userProfile?.columnPref,
      featureFlags: {
        IsWeightBasedRoutingEnabled: this.props.featureFlags.isFeatureEnabled(
          appConstant.features.isWeightBasedRouting
        ),
        enableUnattendedDeliveryInCustomerManagement:
          this.props.configJSON.enableUnattendedDeliveryInCustomerManagement
      },
      terminalAccessLabel: this.props.configJSON.terminalAccessLabel,
      ROUTENAME_EDITOR_PARAMS: this.props.configJSON?.routeNameEditParams,
      columnConfig: this.props.configJSON?.gridColumnConfig,
      enableFixedEquipmentSize: this.props.configJSON.enableFixedEquipmentSize,
      shouldShowTwoManInTrailerInventory: this.props.configJSON.shouldShowTwoManInTrailerInventory,
      enableNoCargoVanCustomer: this.props.configJSON.enableNoCargoVanCustomer,
      enableRevenueFieldsOnUI: this.props.configJSON.enableRevenueFieldsOnUi
    });
    this.selectedShipmentProIdList = [];
    this.isAnyFilterSet = false;
    this.state = {
      quickFilterText: '',
      showProImagesPopup: false,
      proIdList: [],
      filterData: '',
      geocodeShipment: null,
      isRouteConfirmModalVisible: false,
      showEquipmentConfirmationDialog: false,
      showHoldProPopup: false,
      holdProIdList: [],
      proImagesProNumber: null,
    };
    this.gridHeaderId = `gridHeader_${this.props.glContainer._config.id}`;
    this.isRoutesView = false;
    const glContainer = this.props.glContainer;
    if (glContainer && glContainer._config && glContainer._config.location) {
      this.isRoutesView = glContainer._config.location.includes("routes");
    }
    this.serviceLevelList = this.props.IBPlanningStore.serviceLevelList;
    this.gridContext = {
      routesList: this.props.IBPlanningStore.routesList,
      newShipments: this.props.IBPlanningStore.newShipments,
      hasProImagesURL: this.props.configJSON.enableDispatch || Boolean(this.props.configJSON.proImagesUrl),
      specialNeedsOptions: getSpecialNeedsOptionsWithServiceLevel(this.serviceLevelList, appConstant.SpecialNeedsExclusionList.shipmentGrid, appConstant.gridNames.IBShipmentsGrid),
      enableFMECustomer: this.props.configJSON?.enableFMECustomer,
      enableHoldPros: this.props.configJSON.enableHoldPros,
      planDate: this.props.userData.userProfile.planDate,
      getTrailerNameForRoute: this.props.IBPlanningStore.getTrailerNameForRoute,
      getTrailerInfo: this.props.CommonStore.getTrailerInfo,
    };
    this.gridApi = {};
    this.datarefreshed = true;
  }

  componentDidMount() {
    this.autorunDispose = autorun(() => {
      if (
        !isEqual(
          this.selectedShipmentProIdList,
          this.props.IBPlanningStore.selectedShipmentIDList
        )
      ) {
        this.selectShipments(
          this.props.IBPlanningStore.selectedShipmentIDList,
          !this.datarefreshed
        );
      }
      if (this.isRoutesView) {
        const { selectedRouteNameList, routesList } =
          this.props.IBPlanningStore;
        if (selectedRouteNameList.length > 0) {
          const plannedRoutesCount = routesList.filter(
            (route) =>
              selectedRouteNameList.includes(route.routeName) &&
              route.routeName != appConstant.UNRTD_ROUTENAME &&
              !route.isTrapRoute
          ).length;
          if (plannedRoutesCount === 0) {
            this.props.glEventHub.emit(
              `${this.gridHeaderId}_activateTab`,
              this.props.glContainer._config.id
            );
          }
        }
      }
    });

    this.autorunPriorityShipmentList = autorun(() => {
      if (
        !isEqual(
          this.serviceLevelList,
          this.props.IBPlanningStore.serviceLevelList
        )
      ) {
        this.serviceLevelList = this.props.IBPlanningStore.serviceLevelList;
        this.gridContext = {
          ...this.gridContext,
          routesList: this.props.IBPlanningStore.routesList,
          newShipments: this.props.IBPlanningStore.newShipments,
          hasProImagesURL: this.props.configJSON.enableDispatch || Boolean(this.props.configJSON.proImagesUrl),
          specialNeedsOptions: getSpecialNeedsOptionsWithServiceLevel(this.serviceLevelList, appConstant.SpecialNeedsExclusionList.shipmentGrid, appConstant.gridNames.IBShipmentsGrid),
          enableFMECustomer: this.props.configJSON?.enableFMECustomer,
          enableHoldPros: this.props.configJSON.enableHoldPros,
        };
      }
    });

    this.autorunNewShipmentsDispose = autorun(() => {
      if (
        this.props.IBPlanningStore.newShipments.data &&
        this.props.IBPlanningStore.newShipments.data.slice()
      ) {
        this.refreshViolationColumn();
      }
    });

    this.autorunShipmentRefreshed = autorun(() => {
      if (this.props.IBPlanningStore.shipmentsList.slice()) {
        this.datarefreshed = true;
      }
    });

    this.autorunEquipPrefUpdate = autorun(() => {
      this.updateQuickFilterData();
    });

    this.props.glEventHub.on(
      appConstant.Event.SHIPMENT_SELECTED_MAP,
      this.onShipmentSelectedOnMap
    );
    this.props.glEventHub.on(
      appConstant.Event.STOP_SELECTED_MAP,
      this.onStopSelectedOnMap
    );
    this.props.glEventHub.on(`${this.gridHeaderId}`, this.onSearchTextChanged);
    this.props.glEventHub.on(
      `${this.gridHeaderId}_BulkUpdate`,
      this.onBulkUpdate
    );
    this.props.glEventHub.on(
      `${this.gridHeaderId}_geocode`,
      this.geocodeSelectedShipments
    );
    this.routeToTrailerMapDispose = reaction(
      () => ({
        routeWithTrailerName: this.props.IBPlanningStore.routeWithTrailerName,
        trailerInfo: this.props.CommonStore.trailerInfo
      }),
      () => {
        this.refreshViolationColumn();
      }
    );
  }

  componentWillUnmount() {
    this.props.glEventHub.off(
      appConstant.Event.SHIPMENT_SELECTED_MAP,
      this.onShipmentSelectedOnMap
    );
    this.props.glEventHub.off(`${this.gridHeaderId}`, this.onSearchTextChanged);
    this.props.glEventHub.off(
      `${this.gridHeaderId}_BulkUpdate`,
      this.onBulkUpdate
    );
    this.props.glEventHub.off(
      `${this.gridHeaderId}_geocode`,
      this.geocodeSelectedShipments
    );
    this.props.glEventHub.off(
      appConstant.Event.STOP_SELECTED_MAP,
      this.onStopSelectedOnMap
    );
    this.autorunDispose && this.autorunDispose();
    this.autorunNewShipmentsDispose && this.autorunNewShipmentsDispose();
    this.autorunShipmentRefreshed && this.autorunShipmentRefreshed();
    this.autorunPriorityShipmentList && this.autorunPriorityShipmentList();
    this.autorunEquipPrefUpdate?.();
    this.routeToTrailerMapDispose?.();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.userData.userProfile.terminal.id !== prevProps.userData.userProfile.terminal.id
    ) {
      this.gridContext.planDate = this.props.userData.userProfile.planDate;
    }
  }


  runCommand = (command, data) => {
    /* once Latitude/Longitude get updated using geocoding popup in grid, we need to show updated marker in geocoding popup map */
    let selectedShipment;
    if (command === "openGeoCodeModel") {
      if (this.isRoutesView) { 
        selectedShipment = this.props.IBPlanningStore.filteredRouteShipments.find(
          (routesShipment) => data.proId === routesShipment.proId,
        );
      } else {
        selectedShipment = this.props.IBPlanningStore.filteredShipments.find(
          (shipment) => data.proId === shipment.proId,
        );
      }
      this.setState({
        geocodeShipment: getShipmentCustomerData(selectedShipment),
      });
    }
  };

  refreshViolationColumn = () => {
    if (this.gridApi.refreshCells) {
      this.gridApi.refreshCells({ columns: ["violation"], force: true });
    }
    this.gridApi.onFilterChanged?.();
  };

  geocodeSelectedShipments = () => {
    const selectedShipments = this.gridApi.getSelectedRows();
    if (!selectedShipments.length) {
      return;
    }

    this.setState({
      geocodeShipment: {
        ...getShipmentCustomerData(selectedShipments[0]),
        proId: selectedShipments[0].proId,
      },
    });

    //Log Telemetry
    const eventSpecificData = {
      shipments: selectedShipments[0].proId,
    };
    RMAXLogger.info("Geocode", eventSpecificData);
  };

  closeGeocodeModal = (hasDataChanged = false) => {
    if (hasDataChanged) {
      this.props.glEventHub.emit("DispatchEvents", "RefreshIBStore", [{
          showNotification: false,
          selectedRoutesList: this.isRoutesView
          ? this.props.IBPlanningStore.selectedRouteNameList
          : null,
          selectedShipmentsList: [this.state.geocodeShipment.proId]
      }]);
    }
    this.setState({
      geocodeShipment: null,
    });
  };

  onSearchTextChanged = (searchText) => {
    this.setState({
      quickFilterText: searchText,
    });
  };
  selectShipments = (shipmentList, ensureIndexVisible = true) => {
    if (this.gridApi && this.gridApi.forEachNode) {
      this.gridApi.forEachNode((node) => {
        if (shipmentList.includes(node.data.proId)) {
          node.setSelected(true, false, true);
          if (ensureIndexVisible) {
            this.gridApi.ensureIndexVisible(node.rowIndex);
          }
        } else {
          node.setSelected(false, false, true);
        }
      });
      this.gridApi.dispatchEvent({
        type: "selectionChanged",
        api: this.gridApi,
      });
    }
  };
  onShipmentSelectedOnMap = (proId) => {
    if (this.gridApi) {
      const selectedNode = this.gridApi
        .getSelectedNodes()
        .find((node) => node.data.proId === proId);
      if (selectedNode) {
        // if prodId is already selected move it back into the view
        this.gridApi.ensureIndexVisible(selectedNode.rowIndex);
      }
    }
  };

  onStopSelectedOnMap = (routeStopId) => {
    if (this.gridApi) {
      this.gridApi.forEachNodeAfterFilter((node) => {
        if (node.data.routeStopId === routeStopId) {
          node.setSelected(true, false, true);
          this.gridApi.ensureIndexVisible(node.rowIndex);
        } else {
          node.setSelected(false, false, true);
        }
      });
      this.gridApi.dispatchEvent({
        type: "selectionChanged",
        api: this.gridApi,
      });
    }
  };

  onGridReady = ({ api }) => {
    this.gridApi = api;
    this.resizeRouteColumn({api});
    this.selectShipments(this.props.IBPlanningStore.selectedShipmentIDList);
    this.gridApi.runCommand = this.runCommand;
  };

  resizeRouteColumn = ({api}) => {
    api.autoSizeColumns(["routeName"])
  }

  onSelectionChanged = (event) => {
    if (this.gridApi) {
      this.selectedShipmentProIdList = this.gridApi
        .getSelectedRows()
        .map((shipment) => shipment.proId);
      if (
        !isEqual(
          this.selectedShipmentProIdList,
          this.props.IBPlanningStore.selectedShipmentIDList
        )
      ) {
        // this.props.IBPlanningStore.updateSelectedShipments(this.selectedShipmentProIdList);
        this.props.glEventHub.emit("UpdateIBStore", "updateSelectedShipments", [
          this.selectedShipmentProIdList,
        ]);
      }
    }
  };

  onCellValueChanged = (params) => {
    const proIdList = [params.data.proId];
    const field = params.colDef.field;
    let additionalFields = {};
    let value = params.value;
    if (field === "shipmentCTA") {
      value = params.value || "";
    }
    if (field === 'routeName') {
      const shouldOpenHoldProPopup = params.data.isOnHold && !params.value?.isTrapRoute;  
      if (shouldOpenHoldProPopup && !params.value?.isNewValue) {
        this.openCloseHoldProPopup(proIdList);
        params.data[field] = params.oldValue;
        this.gridApi.refreshCells({ columns: [field], force: true });
        return;
      }
    }
    if (this.isUpdateValid({ proIdList, field, value, currentCell: params })) {
      // For inline edit we are backing up data here because we wont get previous value from anywhere else
      if (isEquipmentSizeField(field)) {
        additionalFields = getRelatedEquipmentFields(field, this.props.configJSON.enableFixedEquipmentSize);
        additionalFields = additionalFields.reduce((acc, otherField) => {
          acc[otherField] = params.data[otherField];
          return acc;
        }, {})
      }
      this.shipmentBackupData = {};
      this.shipmentBackupData[params.data.proId] = {
        [field]: params.oldValue,
        ...additionalFields
      };
      if (field === "routeName") {
        params.data[field] =
          params.value && params.value.label ? params.value.label : null;
        this.getTrapInfoAndUpdateShipment({ proIdList, field, value, hasHoldPro: params.data.isOnHold ?[proIdList] : []});
      } else {
        this.updateShipmentInfo({ proIdList, field, value });
      }
    } else {
      params.data[field] = params.oldValue;
      this.gridApi.refreshCells({ columns: [field], force: true });
    }
  };

  getSelectedEditableShipments = (field) => {
    const columnDef = this.gridApi.getColumnDef(field);
    if (columnDef && typeof columnDef.editable === "function") {
      return this.gridApi
        .getSelectedNodes()
        .filter((node) => columnDef.editable(node))
        .map((node) => node.data);
    }
    return this.gridApi.getSelectedRows();
  };

  onBulkUpdate = ({ field, newValue }) => {
    let hasHoldPro = false;
    if (field === "shipmentCTA") {
      newValue = newValue || "";
    }
    let proIdList = this.getSelectedEditableShipments(field).map(
      (shipment) => shipment.proId
    );
    if (field === 'routeName') {
      const selectedRows = this.gridApi.getSelectedRows(); 
      hasHoldPro = selectedRows.filter((row) => row.isOnHold).map((shipment) => shipment.proId);
      if (hasHoldPro.length && !newValue?.isTrapRoute && !newValue?.isNewValue) {
        this.openCloseHoldProPopup(hasHoldPro);
        return;
      }
      proIdList = selectedRows
        .filter((shipment) => shipment.isInPlan)
        .map((shipment) => shipment.proId);
    }
    let currentCell = null;
    if (proIdList.length === 1) {
      currentCell = {
        oldValue: this.gridApi.getSelectedRows()[0][field],
      };
    }
    if (
      this.isUpdateValid({
        proIdList,
        field,
        value: newValue,
        currentCell,
        isBulkEdit: true,
      })
    ) {
      this.updateShipmentUI({ proIdList, field, value: newValue });
      if (field === "routeName") {
        this.getTrapInfoAndUpdateShipment({
          proIdList,
          field,
          value: newValue,
          hasHoldPro,
        });
      }else if(isEquipmentSizeField(field)){
        this.getEquipmentInfoAndUpdateShipment({
          proIdList,
          field,
          value: newValue,
        });
      } else {
        this.updateShipmentInfo({ proIdList, field, value: newValue });
      }
    }
  };

  isUpdateValid = ({ proIdList, field, value, currentCell, isBulkEdit }) => {
    if (proIdList.length === 0) {
      if (field === "shipmentEtaDateTime") {
        this.props.enqueueSnackbar(
          MESSAGES.SHIPMENT_UPDATE.NO_NON_ARRIVED_SHIPMENT_SELECTED,
          { variant: "error" }
        );
      } else if (field === "routeName") {
        this.props.enqueueSnackbar(
          MESSAGES.SHIPMENT_UPDATE.NO_INPLAN_SHIPMENT_SELECTED,
          { variant: "error" }
        );
      } else {
        this.props.enqueueSnackbar(
          MESSAGES.SHIPMENT_UPDATE.NO_SHIPMENT_SELECTED,
          { variant: "error" }
        );
      }
      return false;
    }
    let isUpdateValid = true;
    switch (field) {
      case "routeName":
        // if route didnt change or we reassigned null the update is invalid
        if (!value) {
          this.props.enqueueSnackbar(MESSAGES.SHIPMENT_UPDATE.ROUTE_EMPTY, {
            variant: "error",
          });
          isUpdateValid = false;
        } else if (
          currentCell &&
          (currentCell.oldValue === value ||
            (value && currentCell.oldValue === value.label))
        ) {
          isBulkEdit &&
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info",
            });
          isUpdateValid = false;
        } else {
          const selectedRows = this.gridApi.getSelectedRows();
          const gloveRouteError = handleWhiteGloveProMove({
            shipments: selectedRows,
            routeName: value.label,
            snackbar: this.props.enqueueSnackbar
          });
          if (gloveRouteError) {
            isUpdateValid = false;
          }
        }

        break;
      case "liftgate":
        if (
          currentCell &&
          (Boolean(currentCell.oldValue) === Boolean(value) ||
            (value && currentCell.oldValue === value.value))
        ) {
          isBulkEdit &&
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info",
            });
          isUpdateValid = false;
        }
        break;
      case "shipmentEtaDateTime":
        // Show empty error message on single edit when old value was not null and always on bulk edit
        if (
          (currentCell && currentCell.oldValue && !value) ||
          (!currentCell && !value)
        ) {
          this.props.enqueueSnackbar(MESSAGES.SHIPMENT_UPDATE.IBETA_EMPTY, {
            variant: "error",
          });
          isUpdateValid = false;
        }
        if (value && !isDateTimeValid(value)) {
          this.props.enqueueSnackbar(MESSAGES.SHIPMENT_UPDATE.IBETA_INVALID, {
            variant: "error",
          });
          isUpdateValid = false;
        } else if (currentCell && currentCell.oldValue === value) {
          isBulkEdit &&
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info",
            });
          isUpdateValid = false;
        }
        break;
      case "weight":
      case "hu":
        if (value === "") {
          const fieldName = field === "weight" ? "Weight" : "HU";
          this.props.enqueueSnackbar(
            `Cannot assign empty value to ${fieldName}`,
            { variant: "error" }
          );
          isUpdateValid = false;
        } else if (
          currentCell &&
          Number(currentCell.oldValue) === Number(value)
        ) {
          isBulkEdit &&
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info",
            });
          isUpdateValid = false;
        }
        break;
      case "pse":
        if (value === "") {
          this.props.enqueueSnackbar(MESSAGES.SHIPMENT_UPDATE.PSE_EMPTY, {
            variant: "error",
          });
          isUpdateValid = false;
        } else if (value === 0) {
          this.props.enqueueSnackbar(MESSAGES.SHIPMENT_UPDATE.PSE_ZEROVALUE, {
            variant: "error",
          });
          isUpdateValid = false;
        } else if (
          currentCell &&
          Number(currentCell.oldValue) === Number(value)
        ) {
          isBulkEdit &&
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info",
            });
          isUpdateValid = false;
        }
        break;
      case "preparationTime":
        if (value === "") {
          this.props.enqueueSnackbar(MESSAGES.SHIPMENT_UPDATE.PREPTIME_EMPTY, {
            variant: "error",
          });
          isUpdateValid = false;
        } else if (isNaN(value)) {
          this.props.enqueueSnackbar(
            MESSAGES.SHIPMENT_UPDATE.PREPTIME_INVALID,
            { variant: "error" }
          );
          isUpdateValid = false;
        } else if (currentCell && currentCell.oldValue === value) {
          isBulkEdit &&
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info",
            });
          isUpdateValid = false;
        }
        break;
      case "shipmentCTA":
        if (
          this.props.configJSON?.gridColumnConfig === COLUMN_CONFIG.SAIA &&
          !value
        ) {
          this.props.enqueueSnackbar(
            MESSAGES.SHIPMENT_UPDATE.EARLY_LATE_CTA_EMPTY,
            { variant: "error" }
          );
          isUpdateValid = false;
        } else if (value && value.split("-").length != 2) {
          this.props.enqueueSnackbar(
            MESSAGES.SHIPMENT_UPDATE.EARLY_LATE_CTA_INVALID,
            { variant: "error" }
          );
          isUpdateValid = false;
        } else if (currentCell && currentCell.oldValue === value) {
          isBulkEdit &&
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info",
            });
          isUpdateValid = false;
        }
        break;
      case "minEquipmentSize":
      case "maxFeasibleTrailerLength":
      case "fixedEquipmentSize":
        if (currentCell && (currentCell.oldValue === value || parseInt(currentCell.oldValue) === parseInt(value?.label))) {
          isBulkEdit &&
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info",
            });
          isUpdateValid = false;
        } else if (field !== 'fixedEquipmentSize' && !this.isEquipmentSizeUpdateValid(field, value)) {
            isUpdateValid = false;
        }
        break;
        case "isCargoVanEligible":         
        case "isTwoManRequired":
          if (
            currentCell &&
            (Boolean(currentCell.oldValue) === Boolean(value) ||
              (value && currentCell.oldValue === value.label))
          ) {
            isBulkEdit &&
              this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
                variant: "info",
              });
            isUpdateValid = false;
          }
          break;
      default:
        if (currentCell && currentCell.oldValue === value) {
          isBulkEdit &&
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info",
            });
          isUpdateValid = false;
        }
        break;
    }
    return isUpdateValid;
  };

  isEquipmentSizeUpdateValid = (field, value) => {
    let hasPickupShipment = false;
    const selectedRows = this.gridApi.getSelectedRows();
    const isEquipmentUpdateInvalid = selectedRows.some((shipment) => {
      const { maxFeasibleTrailerLength, minEquipmentSize } = shipment;
      const minEquipLength = field === 'minEquipmentSize' ? value?.label : minEquipmentSize;
      const maxEquipLength = field === 'minEquipmentSize' ? maxFeasibleTrailerLength : value?.label;
      hasPickupShipment = !hasPickupShipment && !shipment.isDelivery;
      return (minEquipLength && maxEquipLength) && maxEquipLength <= minEquipLength;
    });
    if (hasPickupShipment) {
      this.props.enqueueSnackbar(MESSAGES.EQUIPMENT.PICKUP_SHIPMENT, {
        variant: 'error'
      });
    } else if (isEquipmentUpdateInvalid) {
      this.props.enqueueSnackbar(MESSAGES.EQUIPMENT.INVALID_UPDATE[field], {
        variant: "error",
      });
    }
    return !(hasPickupShipment || isEquipmentUpdateInvalid);
  };

  // Updates the UI (which in turn will updated the store) to display updated values & creates a backup of existing values for restore on failure
  updateShipmentUI = ({ proIdList, field, value }) => {
    this.shipmentBackupData = {};
    if (field === "routeName") {
      value = value.label || value;
    }
    this.gridApi.getSelectedRows().map((shipment) => {
      if (proIdList.includes(shipment.proId)) {
        const backupData = {
          [field]: shipment[field],
        };
        if (isEquipmentSizeField(field)) {
          const additionalFields = getRelatedEquipmentFields(
            field,
            this.props.configJSON.enableFixedEquipmentSize
          );
          additionalFields.forEach(otherField => {
            backupData[otherField] = shipment[otherField];

            // Ensure that at most one of 'fixedEquipmentSize' or 'minEquipmentSize'/'maxFeasibleTrailerLength' is set at a time.
            const validLengthFields = ['minEquipmentSize', 'maxFeasibleTrailerLength'];
            const areBothValidLengthFields =
              validLengthFields.includes(field) && validLengthFields.includes(otherField);
            if (!areBothValidLengthFields) {
              shipment[otherField] = null;
            }
          });
        }
        this.shipmentBackupData[shipment.proId] = backupData;
        shipment[field] = value;
      }
    });
    this.gridApi.refreshCells();
  };

  // Updates the UI(which in turn will updated the store) to the value available from backup
  restoreShipmentData = ({ proIdList, field }) => {
    this.gridApi.forEachNode((node) => {
      if (proIdList.includes(node.data.proId)) {
        const backupData = this.shipmentBackupData[node.data.proId];
        node.data[field] = backupData[field];
        if (isEquipmentSizeField(field)) {
          const additionalFields = getRelatedEquipmentFields(field, this.props.configJSON.enableFixedEquipmentSize);
          additionalFields.forEach(otherField => {
            node.data[otherField] = backupData[otherField];
          })
        }
      }
    });
    this.selectShipments(proIdList, true);
    this.gridApi.refreshCells();
  };

  getFieldValueBasedOnCondition = ({ field, otherField, shipment }) => {
    if (otherField === 'fixedEquipmentSize') {
      return this.props.configJSON.enableFixedEquipmentSize ? null : undefined;
    }
    const validLengthFields = ['minEquipmentSize', 'maxFeasibleTrailerLength'];
    const areBothValidLengthFields =
      validLengthFields.includes(field) && validLengthFields.includes(otherField);
    if (areBothValidLengthFields) {
      return shipment[otherField];
    }
    return null;
  };

  getRequestParams = ({ proIdList, field, value }) => {
    let requestParams = {
      scenarioId: this.props.userData.userProfile.scenarioID,
    };
    if (field === "routeName") {
      requestParams.routeName = value ? value.label : null;
      requestParams.isTrapRoute = value ? value.isTrapRoute : null;
      requestParams.pros = proIdList;
    } else if (["liftgate", "isCargoVanEligible", "isTwoManRequired"].includes(field)) {
      requestParams.pros = proIdList.map((proId) => ({
        proId,
        [field]: value ? Boolean(value.value) : false,
      }));
    } 
    else if (isEquipmentSizeField(field)) {
      const additionalFields = getRelatedEquipmentFields(field, this.props.configJSON.enableFixedEquipmentSize);
      requestParams.customers = this.getSelectedEditableShipments()?.map((shipment) => ({
        customerId: shipment.customerId,
        [field]: value ? parseInt(value.label) : null,
        ...additionalFields.reduce((acc, otherField) => {
          acc[otherField] = this.getFieldValueBasedOnCondition({field, otherField, shipment});
          return acc;
        }, {})
      }));
    } else {
      requestParams.pros = proIdList.map((proId) => ({
        proId,
        [field]: value,
      }));
    }
    return requestParams;
  };

  getTrapInfoAndUpdateShipment = ({ proIdList, field, value, hasHoldPro = false }) => {
    if (value && value.isNewValue) {
      this.updateObject = { proIdList, field, value, hasHoldPro };
      this.showRouteConfirmationModal();
      return;
    } else if (
      value &&
      !value.isNewValue &&
      this.props.IBPlanningStore.routesList
    ) {
      const route = this.props.IBPlanningStore.routesList.find(
        (r) => r.routeId === value.value
      );
      if (route) {
        value.isTrapRoute =
          route.routeName === "UNRTD" ? true : route.isTrapRoute;
      }
    }
    this.updateShipmentInfo({ proIdList, field, value });
  };

  getEquipmentInfoAndUpdateShipment = ({ proIdList, field, value }) => {
    this.equipmentUpdateData = { proIdList, field, value };
    const { hasFixedEquipmentSize, hasMaxEquipmentSize, hasMinEquipmentSize } = Object.values(
      this.shipmentBackupData
    ).reduce(
      (acc, shipment) => {
        if (shipment.fixedEquipmentSize) {
          acc.hasFixedEquipmentSize = true;
        }
        if (shipment.maxFeasibleTrailerLength) {
          acc.hasMaxEquipmentSize = true;
        }
        if (shipment.minEquipmentSize) {
          acc.hasMinEquipmentSize = true;
        }
        return acc;
      },
      { hasFixedEquipmentSize: false, hasMaxEquipmentSize: false, hasMinEquipmentSize: false }
    );
    if (hasFixedEquipmentSize && (hasMaxEquipmentSize || hasMinEquipmentSize)) {
      this.showEquipmentConfirmationModal();
      return;
    }
    this.updateShipmentInfo({ proIdList, field, value });
  };

  getUpdateAPI = (field) => {
    switch (field) {
      case "routeName":
        return "UpdateShipmentRouteAssignment";
      case "minEquipmentSize":
      case "maxFeasibleTrailerLength":
      case "fixedEquipmentSize":
        return "UpdateCustomerTrailerLengthPreference";
      default:
        return "UpdateShipmentsProperty";
    }
  };

  updateShipmentInfo = ({ proIdList, field, value }) => {
    const requestParams = this.getRequestParams({
      proIdList,
      field,
      value,
    });
    this.props.glEventHub.emit(`${this.gridHeaderId}_DisableEditSave`, true);
    const { headerTooltip } = this.gridApi.getColumnDef(field);
    const updateAPI = this.getUpdateAPI(field);
    postData(updateAPI, requestParams).then(
      (response) => {
        if (response && Math.trunc(response.status / 100) === 2) {
          this.props.enqueueSnackbar(`${headerTooltip} updated`, {
            variant: "success",
          });
          this.props.glEventHub.emit(
            `${this.gridHeaderId}_showEditMode`,
            false
          );
          //Events.emit("RefreshIBStore", false, this.isRoutesView ? this.props.IBPlanningStore.selectedRouteNameList : null, this.gridApi.getSelectedRows().map(shipment => shipment.proId));
          this.props.glEventHub.emit("DispatchEvents", "RefreshIBStore", [
            {
              showNotification: false,
              selectedRoutesList: this.isRoutesView
              ? this.props.IBPlanningStore.selectedRouteNameList
              : null,
              selectedShipmentsList: this.gridApi.getSelectedRows().map((shipment) => shipment.proId)
            }]);
          this.props.glEventHub.emit(
            `${this.gridHeaderId}_DisableEditSave`,
            false
          );
          return;
        }
        this.handleError({ proIdList, field, headerTooltip, response});
      },
      () => {
        this.handleError({ proIdList, field, headerTooltip});
      }
    );

    //Log Telemetry
    if (field === "routeName") {
      const eventSpecificData = {
        route: requestParams.routeName,
      };
      RMAXLogger.info("RouteUpdateShipmentsGrid", eventSpecificData);
    } else if (isEquipmentSizeField(field)) {
      RMAXLogger.info("UpdateCustomerTrailerLength", requestParams);
    } else {
      const eventSpecificData = {
        pros: requestParams.pros.map((pro) => pro.proId),
      };
      RMAXLogger.info("ShipmentMetadataUpdate", eventSpecificData);
    }
  };

  handleError = ({ proIdList, field, headerTooltip, response }) => {
    const statusCode = response?.status;
    const errorMessage = response?.response?.data?.error?.message || `Failed to update ${headerTooltip}`;
    this.restoreShipmentData({ proIdList, field });
    this.props.glEventHub.emit(`${this.gridHeaderId}_DisableEditSave`, false);
    if (statusCode === 403) {
      return;
    }
    this.props.enqueueSnackbar(errorMessage, {
      variant: 'error'
    });
  };

  showRouteConfirmationModal = () => {
    this.setState({
      isRouteConfirmModalVisible: true,
    });
  };

  showEquipmentConfirmationModal = () => {
    this.setState({
      showEquipmentConfirmationDialog: true
    })
  }

  closeRouteConfirmationModal = () => {
    this.setState({
      isRouteConfirmModalVisible: false,
    });
    const { proIdList, field } = this.updateObject;
    this.restoreShipmentData({ proIdList, field });
  };

  closeEquipmentConfirmationModal = () => {
    this.setState({
      showEquipmentConfirmationDialog: false
    });
    const { proIdList, field } = this.equipmentUpdateData;
    this.restoreShipmentData({ proIdList, field });
  }

  confirmEquipmentUpdate = () =>{
    this.setState({
      showEquipmentConfirmationDialog:false
    })
    this.updateShipmentInfo({ ...this.equipmentUpdateData });
    delete this.equipmentUpdateData;
  }

  confirmRouteType = (routeType) => {
    this.setState({
      isRouteConfirmModalVisible: false,
    });
    this.updateObject.value.isTrapRoute = routeType === "Trap";
    if (this.updateObject.hasHoldPro.length && routeType !== "Trap") {
      this.openCloseHoldProPopup(this.updateObject.hasHoldPro);
      this.restoreShipmentData({ proIdList: this.updateObject.proIdList, field: this.updateObject.field });
      delete this.updateObject;
      return;
    }
    this.updateShipmentInfo({ ...this.updateObject });
    delete this.updateObject;
  };

  closeProImagesPopup = () => {
    this.setState({
      showProImagesPopup: false,
      proImagesProNumber: null
    });
  };


  onCellClicked = (params) => {
    this.setState({
      proIdList: this.gridApi
        .getSelectedRows()
        .map((shipment) => shipment.proId),
    });
    
    if (
      params.column.colId === "proId" &&
      this.state.proIdList.length === 1 &&
      this.gridContext.hasProImagesURL
    ) {
      this.setState({
        showProImagesPopup: true,
        proImagesProNumber: this.state.proIdList[0]
      });
    }
    
    if (['displayCustomerName', 'displayCustomerCode'].includes(params.column.colId)) {
      const { data } = params.node || {};
      let code, type;
      if (data.isDelivery) {
        code = data.customerCode;
        type = appConstant.CUSTOMER_TAB_TYPE.DELIVERY;
      } else {
        code = data.rmaxShipperCode;
        type = appConstant.CUSTOMER_TAB_TYPE.PICKUP;
      }
      Events.emit('OpenEditCustomerDialog', code, type);
    }  
  };

  doesExternalFilterPass = (node) => {
    switch (this.state.filterData) {
      case "LateShipments":
        return Boolean(
          CheckViolation.checkRouteStartTimeViolation({
            data: node.data,
            planDate: this.props.userData.userProfile.planDate,
          })
        );
      case "NewPros":
        return Boolean(
          CheckViolation.checkProIsNew({
            data: node.data,
            context: this.gridContext,
          })
        );
      default:
        return true;
    }
  };

  updateGridData = (updatedFilterData) => {
    this.setState(
      {
        filterData: updatedFilterData,
      },
      () => this.gridApi.onFilterChanged()
    );
  };

  constructStatusBar = (shipmentsList) => {
    const delayedShipmentsCount = shipmentsList
      ? shipmentsList
          .map((shipments) =>
            Boolean(
              CheckViolation.checkRouteStartTimeViolation({
                data: shipments,
                planDate: this.props.userData.userProfile.planDate,
              })
            )
          )
          .filter((value) => value).length
      : 0;
    const newProsCount = shipmentsList
      ? shipmentsList
          .map((shipments) =>
            Boolean(
              CheckViolation.checkProIsNew({
                data: shipments,
                context: this.gridContext,
              })
            )
          )
          .filter((value) => value).length
      : 0;
    return this.isRoutesView
      ? [
          {
            label: shipmentsList.length + " Shipments",
            filterCondition: "",
          },
          {
            label: newProsCount + " New",
            filterCondition: "NewPros",
          },
          {
            label: delayedShipmentsCount + " Arriving Late",
            filterCondition: "LateShipments",
          },
        ]
      : [
          {
            label: shipmentsList.length + " Shipments",
          },
        ];
  };

  onModelUpdated = () => {

    //this.props.IBPlanningStore.quickFilter is set when we apply quick filter
    const isQuickFilterPresent = this.gridApi.isQuickFilterPresent(); //set when something is searched in searchbar
    const isColumnFilterPresent = this.gridApi.isColumnFilterPresent();
   if (
      isColumnFilterPresent ||
      isQuickFilterPresent ||
      this.props.IBPlanningStore.quickFilter
    ) {
      this.isAnyFilterSet = true;
      const filteredRows = [];
      this.gridApi.forEachNodeAfterFilterAndSort(node => {
        filteredRows.push(node.data);
      });
      this.props.glEventHub.emit("UpdateIBStore", "updateFilteredShipments", [filteredRows]);
    } else {
      if (this.isAnyFilterSet) {
        this.props.glEventHub.emit("UpdateIBStore", "updateFilteredShipments", [
          this.props.IBPlanningStore.shipmentsList,
        ]);
        //this.props.IBPlanningStore.updateFilteredShipments(this.props.IBPlanningStore.shipmentsList);
        this.isAnyFilterSet = false;
      }
    }
  };

  onRowDataUpdated = () => {
    if (this.datarefreshed) {
      this.selectShipments(
        this.props.IBPlanningStore.selectedShipmentIDList,
        false
      );
      this.refreshViolationColumn();
    }
    this.datarefreshed = false;
    this.gridApi?.clientSideRowModel?.filterManager?.onNewRowsLoaded({
      api: this.gridApi,
    });
  };

  updateQuickFilterData = () => {
    this.props.glEventHub.emit('updateEquipmentPreference', this.props.IBPlanningStore.equipPref);
  };

  openCloseHoldProPopup = (proIdList = []) => {
    this.setState({
      showHoldProPopup: !this.state.showHoldProPopup,
      holdProIdList: proIdList
    });
  }

  renderPanelLabel = (filteredData) => (
    <StatusBar
      data={this.constructStatusBar(filteredData)}
      filterGridData={this.updateGridData}
    />
  );

  hasActiveColumnAndQuickFilter = () => {
    return (
      this.gridApi.isColumnFilterPresent() &&
      (this.props.IBPlanningStore.quickFilter || this.gridApi.isQuickFilterPresent())
    );
  };
  
  render() {
    let shipmentsList = [];
    this.selectedShipmentProIdList = [];
    if (this.isRoutesView) {
      shipmentsList =
        this.props.IBPlanningStore.filteredRouteShipments.length > 0
          ? this.props.IBPlanningStore.filteredRouteShipments.slice()
          : [];
    } else {
      shipmentsList =
        this.props.IBPlanningStore.filteredShipments.length > 0
          ? this.props.IBPlanningStore.filteredShipments.slice()
          : [];
    }
    return (
      <Fragment>
        <DataGrid
          defaultColDef={this.gridConfig.config.defaultColDef}
          columnDefs={this.gridConfig.config.columns}
          columnTypes={this.gridConfig.config.columnTypes}
          config={this.gridConfig.config}
          rowSelection={this.gridConfig.config.rowSelection}
          rowDeselection={this.gridConfig.config.rowDeselection}
          rowData={shipmentsList}
          onSelectionChanged={this.onSelectionChanged}
          onGridReady={this.onGridReady}
          panelLabel={this.renderPanelLabel}
          onFirstDataRendered={this.resizeRouteColumn}
          onCellValueChanged={this.onCellValueChanged}
          quickFilterText={this.state.quickFilterText}
          layoutContainer={this.props.glContainer}
          hasActiveColumnAndQuickFilter={this.hasActiveColumnAndQuickFilter}
          onCellClicked={this.onCellClicked}
          deltaRowDataMode={true}
          getRowId={(params) => params.data.proId}
          onRowDataUpdated={this.onRowDataUpdated}
          accentedSort={true}
          isExternalFilterPresent={() => Boolean(this.state.filterData)}
          doesExternalFilterPass={this.doesExternalFilterPass}
          onModelUpdated={this.onModelUpdated}
          context={this.gridContext}
          showErrorMessage={this.props.IBPlanningStore.shipmentGridMessage}
        />
        {this.state.isRouteConfirmModalVisible && (
          <RouteConfirmationModal
            routeName={`${this.updateObject ? this.updateObject.value.label : ''}`}
            close={this.closeRouteConfirmationModal}
            confirm={this.confirmRouteType}
          />
        )}
        {this.state.showEquipmentConfirmationDialog && (
          <CustomConfirmationDialog
            title="Update Equipment Type"
            cancelButtonLabel="Cancel"
            confirmButtonLabel="Update"
            onConfirm={this.confirmEquipmentUpdate}
            onCancel={this.closeEquipmentConfirmationModal}>
            {
              <>
                <div>Selected customers have different equipment types, including fixed, maximum, and minimum sizes.</div>
                <br />
                <div>
                  {`Are you sure you want to update the equip type to '${
                    EQUIPMENT_TYPE_BY_FIELD[this.equipmentUpdateData.field]
                  }' for all the selected customers?`}
                </div>
              </>
            }
          </CustomConfirmationDialog>
        )}
        <Suspense fallback={<AppLoading />}>
          {this.state.showProImagesPopup && (
            <ProImages
              proNumber={this.state.proImagesProNumber}
              show={this.state.showProImagesPopup}
              onClose={this.closeProImagesPopup}
              useDefaultProImageAPIConfig
            />
          )}
        </Suspense>
        {this.state.geocodeShipment && (
          <GeocodingModal
            customer={this.state.geocodeShipment}
            userData={this.props.userData.userProfile}
            close={this.closeGeocodeModal}
          />
        )}
        {this.state.showHoldProPopup && (
          <HoldProPopup
            holdProIdList={this.state.holdProIdList}
            onCancel={this.openCloseHoldProPopup}
          />
        )}
      </Fragment>
    );
  }
}

export default compose(
  withStyles(styles),
  withAppConfig,
  withUserProfile,
  withSnackbar,
  withFeatureFlags
)(ShipmentsGrid);
